import React from "react";

import { makeStyles } from 'tss-react/mui';
import Container from "@mui/material/Container";

const useStyles = makeStyles()(theme => ({
	mainContainer: {
		flex: 1,
		padding: theme.spacing(2),
		height: `calc(100% - 48px)`,
	},

	contentWrapper: {
		height: "100%",
		overflowY: "hidden",
		overflowX: "hidden",
		display: "flex",
		flexDirection: "column",
	},
}));

const MainContainer = ({ children, maxWidth }) => {
	const { classes } = useStyles();

	return (
		<Container className={classes.mainContainer} maxWidth={maxWidth}>
			<div className={classes.contentWrapper}>{children}</div>
		</Container>
	);
};

export default MainContainer;
